import React, { useEffect, useState } from 'react'
import Modal from 'react-responsive-modal'
import { useDispatch, useSelector } from 'react-redux'
import styles from './styles.module.css'
import * as Yup from 'yup'

import Table from '../../../../../components/Table'
import Button from '../../../../../components/Button'
import { Select } from '../../../../../components/ModalInputs'

const validationSchema = Yup.object({
  name: Yup.string().required('обязательное поле').max(30, 'Должно быть не более 30 символов'),

})

export default function ModalComponent({ allRoles, currentRoles, onAssignRole, closeModal, }) {

  const dispatch = useDispatch()

  const [selected, setSelected] = useState(null)

  useEffect(() => {
    // dispatch(getSpecMedGroupsStudents(selected))
    // !selected && dispatch(getSpecMedGroupsGroups())
  }, [selected])

  const renderLi = (data) => {
    const { name, pmid } = data
    return (
      <tr>
        <td
          onClick={() => onAssignRole(pmid)}
          style={{ backgroundColor: currentRoles?.find(el => (el.pmid == pmid)) ? '#3689FF' : '' }}
        >
          {name}
        </td>
      </tr>
    )
  }


  const handleChange = (e) => {
    setSelected(
      { [e.target.name]: e.target.value }
    )
  }

  const handleSubmit = () => {
  }
  return (
    <Modal
      open={!!allRoles}
      onClose={() => false}
      showCloseIcon={false}
      classNames={{
        // overlay: styles.overlay,
        modal: styles.custom
      }}
    >
      <>
        <div className={styles.modalLocal} >
          <div className={styles.tabWrapper} >
            <div className={styles.inputsRow}>
            </div>
            <Table className={styles.table} >
              <thead>
                <tr>
                  <th>Роль</th>
                </tr>
              </thead>
              <tbody>
                {allRoles?.map(renderLi)}
              </tbody>
            </Table>
          </div>
        </div>
        <div className={styles.inputsRow}>
          <Button style={{ margin: '0 auto 20px' }} onClick={closeModal}>Сохранить</Button>
          <Button style={{ margin: '0 auto 20px' }} onClick={closeModal}>Отменить</Button>
        </div>
      </>
    </Modal>

  )
}
